import React, { useState, useEffect } from "react";
import "./style.scss";
import CheckoutGuest from "../../sections/checkout-guest";
import LoginForm from "../../sections/login-form";
import PropTypes from "prop-types";
import ProgressBar from "../../sections/checkout-progress-bar";
import { S_AUTH_TOKEN, S_USER, webStorage } from "../../utils/webStorage";
import useQuery from "../../utils/useQuery";
import { LOGOUT, setUserInfoAction } from "../../redux/actions";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { getGearsProgressBars } from "../../services/gearsCheckoutService";
import InStoreLoginForm from "../../sections/in-store-login-form";
import { clearBillingInfoAction, clearContactInfoAction, clearShippingInfoAction, setMemberTypeAction } from "../../redux/actions/gears-checkout";
import { CMT_GUEST, CMT_MEMBER, CMT_MEMBER_STORE } from "../../utils/checkoutMemberTypes";
import { getToken, getUserInfo } from "../../services/userService";
import api from "../../utils/api";
import { staffInfoSelector } from "../../selectors/application";
import useAccountLogin from "../../hooks/useAccountLogin";
let submitting = false;
const CheckoutLoginPage = ({ page, rendering, fields, lang, match, setUserInfo, logout, clearShippingInfo, clearBillingInfo, clearContactInfo, setMemberType, staffInfo, history }) => {
  const {
    fields: { gearsDeliveryLink }
  } = page;
  const { formFields, inStoreFormFields, selectedBar, progressBar, guestSummaryInfo } = fields;

  const query = useQuery();
  const [inStoreMemberNotFound, setInStoreMemberNotFound] = useState(false);
  const [barProps, setBarProps] = useState({ steps: [] });

  const { loginFailed, loginWrongEmailOrPassword, loginNetworkError, loginAccountLock, temporaryLock, login } = useAccountLogin();
  useEffect(() => {
    if (query.action === "logout" || staffInfo) {
      logout();
    }
    getGearsProgressBars(progressBar, selectedBar).then(value => {
      if (value) setBarProps(value);
    });

    /** Measurements */
    let dataLayer = window.dataLayer || [];
    dataLayer.push({
      event: "checkout",
      step: 1
    });
  }, []);
  const loginRedirect = () => {
    const token = webStorage.get(S_AUTH_TOKEN);
    if (query.redirect) {
      if (query.redirect.startsWith("https://") || query.redirect.startsWith("http://")) {
        global.location.href = `${query.redirect}?token=${token.accessToken}`;
      } else {
        history.replace(query.redirect);
      }
    } else if (gearsDeliveryLink.value) {
      history.replace(gearsDeliveryLink.value.href);
    }
  };
  const submitLogin = async (evt, data) => {
    const { userInfo } = await login(data.email, data.password);
    if (userInfo) {
      setMemberType(CMT_MEMBER);
      clearShippingInfo();
      clearBillingInfo();
      clearContactInfo();
      /** Measurements */
      let dataLayer = window.dataLayer || [];
      dataLayer.push({
        event: "checkoutOption",
        option: "login",
        step: 1
      });
      loginRedirect();
    }
  };
  const onInStoreEmailChanged = () => {
    setInStoreMemberNotFound(false);
  };
  const onInStoreContinue = async (evt, data) => {
    if (!submitting) {
      submitting = true;
      setInStoreMemberNotFound(false);
      const { obj } = await api.email.getUser({
        email: data.email
      });
      if (obj) {
        setUserInfo(obj);
        setMemberType(CMT_MEMBER_STORE);
        /** Measurements */
        let dataLayer = window.dataLayer || [];
        dataLayer.push({
          event: "checkoutOption",
          option: "login",
          step: 1
        });
        if (query.redirect) {
          history.replace(query.redirect);
        } else if (gearsDeliveryLink.value) {
          history.replace(gearsDeliveryLink.value.href);
        }
      } else {
        setInStoreMemberNotFound(true);
      }
      submitting = false;
    }
  };
  const onGuestContinue = evt => {
    setMemberType(CMT_GUEST);
    /** Measurements */
    let dataLayer = window.dataLayer || [];
    dataLayer.push({
      event: "checkoutOption",
      option: "guest",
      step: 1
    });

    if (query.redirect) {
      history.replace(query.redirect);
    } else if (gearsDeliveryLink.value) {
      history.replace(gearsDeliveryLink.value.href);
    }
  };
  return (
    <div className="checkout-login-container grid-story" datasourceid={rendering.dataSource}>
      <div className="steop-routing">
        <ProgressBar {...barProps} />
      </div>
      <div className="checkout-login">
        {!staffInfo && (
          <LoginForm
            {...{
              ...formFields.fields,
              loginFailed,
              loginNetworkError,
              loginAccountLock,
              temporaryLock,
              loginWrongEmailOrPassword,
              lang,
              match,
              submitLogin: (evt, data) => submitLogin(evt, data)
            }}
          />
        )}
        {staffInfo && (
          <InStoreLoginForm
            {...{
              ...inStoreFormFields.fields,
              loginFailed,
              loginNetworkError,
              loginAccountLock,
              inStoreMemberNotFound,
              onEmailChanged: () => onInStoreEmailChanged(),
              onContinue: (evt, data) => onInStoreContinue(evt, data)
            }}
          />
        )}
      </div>
      {guestSummaryInfo && (
        <div className="checkout-guest">
          <CheckoutGuest
            {...{
              ...guestSummaryInfo.fields,
              onContinue: evt => onGuestContinue(evt)
            }}
          />
        </div>
      )}
    </div>
  );
};

CheckoutLoginPage.propTypes = {
  checkoutGuestProps: PropTypes.shape({
    heading: PropTypes.object,
    description: PropTypes.object,
    submitButton: PropTypes.object,
    submitGuest: PropTypes.func
  }),
  checkoutLoginProps: PropTypes.shape({
    heading: PropTypes.object,
    description: PropTypes.object,
    email: PropTypes.object,
    password: PropTypes.object,
    submitButton: PropTypes.object,
    forgotPassword: PropTypes.object,
    submitLogin: PropTypes.func
  }),
  ProgressBarProps: PropTypes.shape({
    steps: PropTypes.array,
    activeStep: PropTypes.object
  })
};
const mapStateToProps = state => ({
  staffInfo: staffInfoSelector(state)
});
const mapDispatchToProps = dispatch => ({
  setUserInfo: data => {
    dispatch(setUserInfoAction(data));
  },
  logout: () => dispatch({ type: LOGOUT }),
  clearShippingInfo: () => dispatch(clearShippingInfoAction()),
  clearBillingInfo: () => dispatch(clearBillingInfoAction()),
  clearContactInfo: () => dispatch(clearContactInfoAction()),
  setMemberType: data => dispatch(setMemberTypeAction(data))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CheckoutLoginPage));
